import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TRequestMapping = {
    [key: string]: Array<Record<string, string>>;
};

const requestMappingSlice = createSlice({
    name: "requestMapping",
    initialState: {
        value: {} as TRequestMapping,
    },
    reducers: {
        updateRequestMapping: (
            state,
            action: PayloadAction<TRequestMapping>
        ) => {
            state.value = action.payload;
        },
    },
});

export const { updateRequestMapping } = requestMappingSlice.actions;
export default requestMappingSlice.reducer;
